import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AttendanceSheetVM } from "@shared-kernel/application/ports/student/student-repository";

export const studentRetrieveUnsignedAttendanceSheets = createAsyncThunk<AttendanceSheetVM[], void, { extra: Partial<Dependencies> }>(
  "attendanceSheets/studentRetrieveUnsignedAttendanceSheets",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getUnsignedAttendanceSheets();
  },
);
